import React from "react";
import { Link } from "react-router-dom";

const IMAGE_BASE_URL =
  "https://mean3.com/";

export default function BlogCard({ blog }) {
  const imageUrl = blog.featured_image
    ? blog.featured_image.startsWith("http")
      ? blog.featured_image
      : `${IMAGE_BASE_URL}${blog.featured_image}`
    : "";

  return (
    <div className="w-full md:w-1/2 xl:w-1/3 flex flex-col max-w-[400px] items-center justify-center blog-container mb-[30px] px-[15px]">
      <Link to={`/blogs/${blog.handle}`} className="w-full">
        <div className="inline-block w-full relative rounded-sm mb-[10px] cursor-pointer group">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={blog.title}
              title={blog.title}
              className="inline-block min-w-[350px] object-cover rounded-sm w-full h-[200px]"
            />
          ) : (
            <div className="w-full h-[200px] bg-gray-200 flex items-center justify-center rounded-sm">
              No Image
            </div>
          )}
        </div>

        <h3 className="my-0 md:my-[10px] text-center md:text-left hover:text-[#cd2122] text-base italic leading-[1.4] cursor-pointer font-open">
          {blog.title}
        </h3>

        {blog.author && (
          <p className="text-sm text-gray-600 text-center md:text-left">
            By{" "}
            <span className="hover:underline hover:text-[#DA2128]">
              {blog.author}
            </span>
          </p>
        )}
      </Link>
    </div>
  );
}